import { useQuery } from "@tanstack/react-query";
import { api, generateQueryKey } from "@/lib/api";
import {
  buildBuyingGroupRequestParams,
  createBuyingGroupQueryKeyPart,
} from "@/lib/buying-group-utils";
import type { BuyingGroupMode } from "./use-account-activities";

export interface FirstTouchpoint {
  date: string;
  person_id: string;
}

export interface FirstTouchpointResponse {
  first_touchpoints: FirstTouchpoint[];
}

export function useAccountFirstTouchpointTimeline(
  accountId?: string,
  opportunityIds?: string[],
  personIds?: string[],
  buyingGroupMode: BuyingGroupMode = "default",
  customGroupOpportunityIds?: string[],
) {
  // Use the shared utility for consistent query key generation
  const queryKey = [
    ...generateQueryKey(
      `datahub/accounts/${encodeURIComponent(
        accountId || "",
      )}/first-touchpoint-timeline/`,
    ),
    createBuyingGroupQueryKeyPart({
      opportunityIds,
      personIds,
      buyingGroupMode,
      customGroupOpportunityIds,
    }),
  ];

  return useQuery<FirstTouchpointResponse>({
    queryKey,
    queryFn: () => {
      // Use the shared utility for consistent parameter building
      const params = buildBuyingGroupRequestParams({
        opportunityIds,
        personIds,
        buyingGroupMode,
        customGroupOpportunityIds,
      });

      return api.get<FirstTouchpointResponse>(
        `datahub/accounts/${encodeURIComponent(
          accountId || "",
        )}/first-touchpoint-timeline/`,
        { params },
      );
    },
    enabled: !!accountId,
  });
}
